// extracted by mini-css-extract-plugin
module.exports = {"footer":"ReorderModal_footer__OQQ5m","subheader":"ReorderModal_subheader__1Jv1Z","listWrap":"ReorderModal_listWrap__eM6G3"};